const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsPedidos = { name: 'Pedidos', pathName: null }

export default [
  {
    path: '/pedidos',
    component: () => import('@/modules/pedidos/views/pages/Pedidos.vue'),
    children: [
      {
        path: 'controle-pedidos',
        component: () => import('@/modules/pedidos/controle-pedidos/views/pages/ControlePedidos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsPedidos,
            {
              name: 'Controle de pedidos',
              pathName: null,
            },
          ],
          title: 'Pedidos',
          permission: 'telesales',
          requiresPiiAccess: true,
        },
      },
      {
        path: 'controle-pedidos/historico',
        component: () => import('@/modules/pedidos/controle-pedidos/views/pages/HistoricoPedidos.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsPedidos,
            {
              name: 'Controle de pedidos',
              pathName: '/pedidos/controle-pedidos',
            },
            {
              name: 'Histórico de pedidos',
              pathName: null,
            },
          ],
          title: 'Pedidos',
          permission: 'telesales',
          requiresPiiAccess: true,
        },
      },
      {
        path: 'gerenciamento-preco',
        component: () => import('@/modules/pedidos/gerenciamento-preco/views/pages/GerenciamentoPreco.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsPedidos,
            {
              name: 'Gerenciamento de preço',
              pathName: null,
            },
          ],
          title: 'Pedidos',
        },
      },
    ],
  },
]
